<template>
  <div>
    <OrderItemList :list="cartPackages"></OrderItemList>
    <CheckoutForm @updateActualAmount="setActualAmount" @updateOrder="setOrderInfo" @confirm="changeConfirmation"></CheckoutForm>
    <div v-transfer-dom>
      <loading :show="isLoading" :text="loadingText"></loading>
    </div>
    <br>
    <br>
    <br>
    <br>
    <CheckoutFooter class="checkout-footer" :currency="$t('kol.priceUnit')" :totalPrice="actualAmount" @createOrder="createOrder" :disable="disable"></CheckoutFooter>
    <!-- <actionsheet v-if="useCredit == false" v-model="showPaymentMethods" :menus="paymentMethodListWithCredit" @on-click-menu="pay"/>
    <actionsheet v-else v-model="showPaymentMethods" :menus="paymentMethodList" @on-click-menu="pay"/> -->
    <actionsheet v-model="showPaymentMethods" :menus="paymentMethodList" @on-click-menu="pay"/>
  </div>
</template>
<script type="text/javascript">

import { Actionsheet, Loading,TransferDomDirective as TransferDom } from 'vux' 

import OrderItemList from '../components/OrderItemList'
import CheckoutFooter from '../components/CheckoutFooter'
import CheckoutForm from '../components/CheckoutForm'

import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'

import { mapGetters } from 'vuex'
import Cookies from 'js-cookie';

export default {
  name: 'Checkout',
  directives: {
    TransferDom
  },
  components: {
    OrderItemList,
    CheckoutFooter,
    CheckoutForm,
    Actionsheet,
    Loading
  },
  props: {
    package:{
      type:Object
    }
  },
  data() {
    return {
      actualAmount: 0,
      order: {},
      orderInfo: {},
      showPaymentMethods: false,
      paymentMethodList: {
        S: this.$t('cart.payment.stripe'),
        T: this.$t('cart.payment.transfer'),
      },
      // paymentMethodListWithCredit: {
      //   S: this.$t('cart.payment.stripe'),
      //   T: this.$t('cart.payment.transfer'),
      //   D: "積分付款"
      // },
      orderNumber: '',
      orderID: '',
      isLoading: false,
      loadingText: this.$t('general.processing'),
      redirectUri: '',
      response: {},
      response2: {},
      disable: true,
      useCredit: false
    }
  },
  created() {
    document.title = `${this.$t('kol.footer.checkout')}`;
    this.$store.commit("hideFooter", true);

    if( (this.addressList == undefined && Cookies.get('redirect') !== 'true') || (this.addressList.length == 0 && Cookies.get('redirect') !== "true") ){
      this.getUserAddress();
    }else if(Cookies.get('redirect')=="true"){
      return;
    }
  },
  mounted() {},
  watch: {},
  computed: {

    ...mapGetters([
      'getHKPrice',
      // 'isWechatEnv'
      ]),
    tariff(){
      return this.$store.getters.tariff;
    },
    shippingFee(){
      return this.$store.getters.shippingFee;
    },
    discount(){
      return this.$store.getters.discount;
    },
    totalPrice(){
      return this.$store.getters.totalPricePackages;
    },
    cartPackages(){
      return this.$store.state.cartPackages;
    },
    currency(){
      return this.$store.state.currency;
    },
    addressList(){
      return this.$store.state.addressList;
    }
  },
  methods: {
    getUserAddress(){
      this.$store.dispatch('getUserAddress', {}).then((json) => {

        if(json.status == 401){
          Cookies.remove('token');
          this.$router.push('/login');
        }else{
          if(this.isEmptyObject(this.$store.state.currentAddress)){
            this.$store.commit('updateCurrentAddress', json.data.list[0]);
          }
          this.$store.commit('updateAddressList', json.data.list);
        }
      }).catch((err) => {
        console.error(err);
      });
    },
    setActualAmount(amount){
      this.actualAmount = parseInt(amount.toFixed(2));
    },
    setOrderInfo(order){
      this.orderInfo = order;
    },
    createOrder(){

      var order = {
        ...this.orderInfo,
        product: this.cartProductsMapping(),
        currency: this.$t('kol.priceUnit'),
        exchangeRate: this.$store.state.exchangeRate,
        actualAmount: this.actualAmount,
      };

      this.isLoading = true;

      this.$store.dispatch('Cart/createOrder', order).then((json) => {
        
        if(json.status == 401){
          Cookies.remove('token');
          this.$router.push('/login');
        }else{
          this.orderNumber = json.data.orderNumber;
          this.orderID = json.data.ID;
          this.redirectUri = json.data.wechatPaymentUrl;
          this.showPaymentMethods = true;
          this.isLoading = false;

        }
      }).catch((err) => {
        console.error(err);
      });      

      
    },
    pay(paymentMethod){

      switch(paymentMethod){
        case 'S':
          this.$router.push({
              name:'Package Payment',
              params:{
                currency: this.$t('kol.priceUnit'),
                orderNumber: this.orderNumber,
                orderID: this.orderID+"",
                actualAmount: this.actualAmount,
                type:paymentMethod
              }
          });
          break;
          case 'T':
          this.$router.push({
              name:'Package Payment',
              params:{
                currency: this.$t('kol.priceUnit'),
                orderNumber: this.orderNumber,
                orderID: this.orderID+"",
                actualAmount: this.actualAmount,
                type:paymentMethod
              }
          });
          break;
        // case 'D':
        //   this.$router.push({
        //        name:'Payment',
        //        params:{
        //          currency: this.$t('kol.priceUnit'),
        //          orderNumber: this.orderNumber,
        //          orderID: this.orderID+"",
        //          actualAmount: this.actualAmount,
        //          type:paymentMethod
        //        }
        //    });
        //   break;
        default:
          break;
      }
    },
    // pullOrderStatus(orderID){
    //   this.$store.dispatch('Cart/getOrderList', {ID: orderID}).then((json) => {
        
    //     if(json.status == 401){
    //       Cookies.remove('token');
    //       this.$router.push('/login');
    //     }else if(json.status == 200){
    //       if(json.data.list[0].status == 'S')

    //     }else{
    //       alert(json.message);
    //     }
    //   }).catch((err) => {
    //     console.error(err);
    //   });        
    // },
    cartProductsMapping(){
      var cartPackages = this.$store.state.cartPackages;
      var packages = [];
      for (var i = cartPackages.length - 1; i >= 0; i--) {
        var p = [];
        p['productID'] = cartPackages[i]['productID'];
        if(cartPackages[i]['kolProductID'] == null){
          p['kolProductID'] = 0
        }else{
          p['kolProductID'] = cartPackages[i]['kolProductID'];
        }
        p['quantity'] = cartPackages[i]['quantity'];
        p['unitPrice'] = cartPackages[i]['unitPrice'];
        packages.push(p);
      }
      return packages;
    },
    isEmptyObject(obj) {
      if (obj == null) {
        return true;
      }
      for (var key in obj) {
        if (obj.hasOwnProperty(key))
          return false;
      }
      return true;
    },
    changeConfirmation(tf){
      this.disable = !tf
    },
    usedCredit(tf) {
      this.useCredit = tf;
    },
  }
}

</script>
<style type="text/css">
.checkout-footer{
  overflow:hidden; 
  position: fixed;
  bottom: 0px;
  width: 100%;
}
</style>




// WEBPACK FOOTER //
// src/Package/containers/Checkout.vue